<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByOrgReferred.p1')}}
    {{news.textParams[2]}}
    <router-link
      :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
    >{{news.textParams[4]}}</router-link>
    {{$t('news.template.proposal.publishByOrgReferred.p2')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>.
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>
    {{$t('news.template.proposal.publishByOrgReferred.p3')}}
    {{news.textParams[2]}}
    {{$t('news.template.proposal.publishByOrgReferred.p4')}}
    {{news.textParams[8]}}.
    {{$t('news.template.proposal.publishByOrgReferred.p5')}}
    {{news.textParams[7]}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{$t('news.template.proposal.publishByOrgReferred.p6')}}
    </router-link>
    {{$t('news.template.proposal.publishByOrgReferred.p7')}}
  </div>
</template>
